module.exports = __webpack_public_path__ + "img/button.694ff81e.jpg";